import * as React from "react"

import Seo from "@/components/seo"
import { Layout } from "@/components"
import t from "@/constants/wording"
import ProductBanner from "@/components/product/banner"
import AllPartner from "@/components/search-partner/all-partner"

const SearchPartnerPage: React.FC = () => {
  return (
    <Layout>
      <Seo
        title={t("Search Partner")}
        description={t("Search Partner")}
        keywords={t("keywords")}
      />
      <ProductBanner
        className="searchPartnerBanner"
        text={t("Search Partner")}
      />
      <AllPartner />
    </Layout>
  )
}

export default SearchPartnerPage
